import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {getCookie, requestURl} from "../../utils/api";
import {authConstants} from "../../constants/authConstants";
import {baseQueryWithReauth} from "./settings";


const baseQuery = (args, api, extraOptions) => fetchBaseQuery(
  {
    baseUrl: requestURl,
    credentials: 'include',
    prepareHeaders: (headers, {getState}) => {
      const token = getCookie(authConstants.accessToken);
      const tokenType = getCookie(authConstants.typeToken);
      const currentTenant = getCookie(authConstants.tenant);
      if (token !== "undefined") {
        // устанавливаем Authorization headers
        headers.set("Authorization", `${tokenType} ${token}`);
        currentTenant && headers.set("X-Tenant-Id", `${currentTenant}`);
      }
      if (extraOptions?.isImg) {
        headers.set("Content-Type", "image/jpeg");
      } else if (extraOptions?.isFile) {
        // headers.set("Content-Type", "multipart/form-data");
      } else {
        headers.set("Content-Type", "application/json");
      }
      return headers
    },
  });


export const apiRedux = createApi({
  reducerPath: 'apiRedux',
  baseQuery: (args, api, extraOptions) => {
    return baseQueryWithReauth(baseQuery(args, api, extraOptions))(args, api, extraOptions)
  },
  endpoints: (builder) => ({}),
})




